"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySelectionModal = void 0;
const react_hook_form_1 = require("react-hook-form");
const project_1 = require("root/src/shared/constants/project");
const commonStyles_1 = require("root/src/client/web/commonStyles");
const react_1 = require("react");
const Icon_1 = __importDefault(require("root/src/client/web/base/Icon"));
const dropKeys_1 = require("root/src/shared/constants/dropKeys");
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const DareDropIcon_1 = __importDefault(require("root/src/client/public/icons/DareDropIcon"));
const ButtonNew_1 = require("root/src/client/v2/common/components/form/ButtonNew");
const modal_context_1 = require("root/src/client/v2/common/contexts/modal.context");
const ModalLayout_1 = require("root/src/client/v2/common/layouts/ModalLayout");
const ProgressBar_1 = __importDefault(require("root/src/client/web/base/ProgressBar"));
const useAccountData_1 = require("root/src/client/v2/userData/hooks/useAccountData");
const useDeliveryRatio_1 = require("root/src/client/v2/userData/hooks/useDeliveryRatio");
const LoadingCircles_1 = __importDefault(require("root/src/client/v2/common/components/LoadingCircles"));
const Tile = __importStar(require("root/src/client/v2/drop/features/KeySelectionModal/components/Tile"));
const useKeySelectionModal_1 = require("root/src/client/v2/drop/features/KeySelectionModal/hooks/useKeySelectionModal");
const initialProduct_guards_1 = require("root/src/shared/rewards/helpers/initialProduct.guards");
exports.KeySelectionModal = (0, react_1.memo)((props) => {
    const { dropEvent } = props;
    const { form, onFormSubmit } = (0, useKeySelectionModal_1.useKeySelectionModal)(props);
    return (<ModalLayout_1.ModalLayout className="sm:min-w-[600px]">
			{/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
			<useKeySelectionModal_1.KeySelectionModalContext.Provider value={{ dropEvent }}>
				<react_hook_form_1.FormProvider {...form}>
					<form onSubmit={onFormSubmit}>
						<div className="flex flex-col justify-center items-center gap-8">
							<KeySelectionModalHeading />
							<InitialProductSelectField />
							<modal_context_1.ModalContextProvider>
								<UserHasGameField />
							</modal_context_1.ModalContextProvider>
							<DeliveryRateInfo />
							<Submit />
						</div>
					</form>
				</react_hook_form_1.FormProvider>
			</useKeySelectionModal_1.KeySelectionModalContext.Provider>
		</ModalLayout_1.ModalLayout>);
});
const KeySelectionModalHeading = (0, react_1.memo)(() => {
    return (<div className="flex flex-col justify-center items-center gap-1">
			<h1 className="font-bold text-2xl text-center">Select Your Platform</h1>
			<span className="text-center">This Drop is available on the platforms below. Click an icon to choose.</span>
		</div>);
});
const PlatformField = (0, react_1.memo)((props) => {
    const { platform } = props;
    const form = (0, useKeySelectionModal_1.useKeySelectionFormContext)();
    const selectedPlatform = form.watch('platform');
    const isSelected = selectedPlatform === platform;
    return (<Tile.Root>
			<Tile.Button data-selected={isSelected} onClick={() => {
            if (!isSelected) {
                form.setValue('platform', platform);
                form.setValue('region', '');
            }
        }}>
				<Icon_1.default color={commonStyles_1.colorsNew.dark3} fillColor={commonStyles_1.colorsNew.light3} textColor={commonStyles_1.colorsNew.dark3} size={54.5} icon={dropKeys_1.platformIconMap[platform]}/>
				<span className="text-dark-2 font-bold text-xs">
					{dropKeys_1.readablePlatformsMap[platform] || platform}
				</span>
			</Tile.Button>
		</Tile.Root>);
});
const DeliveryRateInfo = (0, react_1.memo)(() => {
    const deliveryRatio = (0, useDeliveryRatio_1.useDeliveryRatio)();
    const accountData = (0, useAccountData_1.useAccountData)();
    const deliveryBarColor = getDeliveryRatioColor(deliveryRatio);
    const form = (0, useKeySelectionModal_1.useKeySelectionFormContext)();
    const userHasGame = form.watch('userHasGame');
    const [text, color] = generateDeliveryRateText(deliveryRatio, accountData === null || accountData === void 0 ? void 0 : accountData.deliveryRatioDenominator, userHasGame, deliveryBarColor);
    return (<div className="flex flex-col justify-center items-center gap-2">
			<p className="font-bold text-lg uppercase text-center">Your delivery rate</p>
			<ProgressBar_1.default progress={deliveryRatio * 100} progressBarColor={deliveryBarColor} progressBackgroundColor={commonStyles_1.colorsNew.white} progressBackgroundStyle={{
            boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
        }} progressBarStyle={{
            boxShadow: '2px 1px 4px rgba(0, 0, 0, 0.25)',
            minWidth: deliveryRatio > 0 ? 60 : 0,
        }} progressContentStyle={{
            boxShadow: 'inset 0px -1px 2px rgba(0, 0, 0, 0.25)',
        }}>
				<span className="text-sm text-black w-full text-right mx-2 tabular-nums">
					{`${(deliveryRatio * 100).toFixed(2)}%`}
				</span>
			</ProgressBar_1.default>
			<p className="text-center text-sm font-medium max-w-fit" style={{ color }}>
				{text}
			</p>
		</div>);
});
const RegionField = (0, react_1.memo)((props) => {
    const { region } = props;
    const form = (0, useKeySelectionModal_1.useKeySelectionFormContext)();
    const { field } = (0, react_hook_form_1.useController)({
        name: 'region',
        control: form.control,
    });
    const isSelected = field.value === region;
    return (<Tile.Root>
			<Tile.Button data-selected={isSelected} onClick={() => field.onChange(region)} className="py-0">
				<span className="text-dark-2 uppercase font-bold text-xs">
					{region}
				</span>
			</Tile.Button>
		</Tile.Root>);
});
const InitialProductSelectField = (0, react_1.memo)(() => {
    const form = (0, useKeySelectionModal_1.useKeySelectionFormContext)();
    const { dropEvent } = (0, useKeySelectionModal_1.useKeySelectionModalContext)();
    const { initialProduct = [] } = dropEvent;
    const isKey = initialProduct.some(initialProduct_guards_1.isInitialKey);
    const isCode = initialProduct.some(initialProduct_guards_1.isInitialCode);
    const selectedPlatform = form.watch('platform');
    const userHasGame = form.watch('userHasGame');
    const platforms = (0, react_1.useMemo)(() => {
        return [...new Set(initialProduct
                .filter((product) => {
                return (0, initialProduct_guards_1.isInitialKey)(product);
            })
                .map(product => product.platform)),
        ];
    }, [initialProduct, isKey, isCode]);
    const regions = (0, react_1.useMemo)(() => {
        if (isKey) {
            return [...new Set(initialProduct
                    .filter((product) => {
                    return (0, initialProduct_guards_1.isInitialKey)(product) && product.platform === selectedPlatform;
                })
                    .map(product => product.region)),
            ];
        }
        if (isCode) {
            return [useKeySelectionModal_1.CODE_DEFAULT_REGION];
        }
        return [];
    }, [initialProduct, isKey, isCode, selectedPlatform]);
    return (<div className="flex flex-col gap-4 justify-center items-center relative px-2 py-2">
			{Boolean(platforms.length) && (<ul className="flex flex-wrap justify-center gap-4">
					{platforms.map(platform => (<li key={platform}>
							<PlatformField platform={platform}/>
						</li>))}
				</ul>)}
			{Boolean(regions.length) && (<ul className="flex flex-wrap justify-center gap-4">
					{regions.map(region => (<li key={region}>
							<RegionField region={region}/>
						</li>))}
				</ul>)}
			{userHasGame && (<div className="absolute w-full h-full rounded-xl backdrop-blur-sm"/>)}
		</div>);
});
const UserHasGameDetailsModal = (0, react_1.memo)((props) => {
    const { onConfirm } = props;
    const [isAlreadyOwnProductModalDismissed, setIsAlreadyOwnProductModalDismissed] = (0, useKeySelectionModal_1.useDismissAlreadyOwnProductModal)();
    return (<ModalLayout_1.ModalLayout className="z-[200]">
			<div className="flex flex-col gap-4 text-sm">
				<h1 className="font-bold text-xl">I already own product</h1>
				<p>
					Delivering without getting a product <strong>improves your delivery rate</strong>.
				</p>
				<p>
					You will still be able to deliver dares and earn rewards, but you will not receive a initial key for this drop.
				</p>
				<p>
					This option <strong>cannot be changed</strong> after dare creation.
				</p>
				<FormControlLabel_1.default control={(<Checkbox_1.default checked={isAlreadyOwnProductModalDismissed} onChange={(_, isChecked) => {
                setIsAlreadyOwnProductModalDismissed(isChecked);
            }}/>)} label={<span className="text-sm">Don't show this message again</span>}/>
				<ButtonNew_1.ButtonNew className="font-bold uppercase" onClick={onConfirm}>I understand</ButtonNew_1.ButtonNew>
			</div>
		</ModalLayout_1.ModalLayout>);
});
const UserHasGameField = (0, react_1.memo)(() => {
    const { dropEvent } = (0, useKeySelectionModal_1.useKeySelectionModalContext)();
    const form = (0, useKeySelectionModal_1.useKeySelectionFormContext)();
    const [dismissAlreadyOwnProductModal] = (0, useKeySelectionModal_1.useDismissAlreadyOwnProductModal)();
    const modal = (0, modal_context_1.useModal)();
    const { field } = (0, react_hook_form_1.useController)({
        name: 'userHasGame',
        control: form.control,
        defaultValue: false,
    });
    return (<FormControlLabel_1.default control={(<Checkbox_1.default checked={field.value} onChange={(_, isChecked) => {
                if (!isChecked || dismissAlreadyOwnProductModal) {
                    field.onChange(isChecked);
                    return;
                }
                modal.show(<UserHasGameDetailsModal onConfirm={() => {
                        field.onChange(isChecked);
                        modal.hide();
                    }}/>, { isCloseable: false, zIndex: 300 });
            }}/>)} label={generateGamePossessionText(dropEvent.initialProduct)}/>);
});
const Submit = (0, react_1.memo)(() => {
    var _a;
    const form = (0, useKeySelectionModal_1.useKeySelectionFormContext)();
    const userHasGame = form.watch('userHasGame');
    const platform = form.watch('platform');
    const region = form.watch('region');
    const { dropEvent } = (0, useKeySelectionModal_1.useKeySelectionModalContext)();
    const initialProducts = (_a = dropEvent.initialProduct) !== null && _a !== void 0 ? _a : [];
    const isKey = initialProducts.some(initialProduct_guards_1.isInitialKey);
    const isCode = initialProducts.some(initialProduct_guards_1.isInitialCode);
    const isLoading = form.formState.isSubmitting;
    const isDisabled = isLoading || !form.formState.isValid || (!userHasGame && isKey && (!platform || !region));
    return (<ButtonNew_1.ButtonNew disabled={isDisabled} className="flex justify-center items-center gap-1 px-2 py-1.5" type="submit">
			{isLoading ? <LoadingCircles_1.default width={33} height={33}/> : <Icon_1.default icon={DareDropIcon_1.default} size={33}/>}
			<span className="font-bold uppercase text-xl">
				{userHasGame ? 'Create dare!' : `Create dare and get ${isKey ? 'key' : isCode ? 'code' : 'product'}!`}
			</span>
		</ButtonNew_1.ButtonNew>);
});
function getDeliveryRatioColor(ratio) {
    return Object.entries(project_1.deliveryRatioColor)
        .reduce((acc, [threshold, text]) => {
        return ratio >= Number(threshold) ? text : acc;
    }, project_1.deliveryRatioColor['0']);
}
function generateDeliveryRateText(ratio, deliveryRatioDenominator, userHasGame, deliveryBarColor) {
    if (userHasGame) {
        return ['Delivering without getting a key improves your rate.', commonStyles_1.colorsNew.green];
    }
    if (deliveryRatioDenominator === undefined
        || deliveryRatioDenominator <= project_1.minDropsStartsToCount) {
        return ['Stream & deliver dares to keep access to drops.',
            deliveryRatioDenominator ? deliveryBarColor : commonStyles_1.colorsNew.green];
    }
    return [Object.entries(project_1.deliveryRatioThresholds)
            .reduce((acc, [threshold, text]) => (ratio >= Number(threshold) ? text : acc), project_1.deliveryRatioThresholds['0']), deliveryBarColor];
}
function generateGamePossessionText(initialProducts) {
    const initialProduct = initialProducts === null || initialProducts === void 0 ? void 0 : initialProducts.at(0);
    if (!initialProduct) {
        return 'I don\'t have this product yet.';
    }
    if ((0, initialProduct_guards_1.isInitialKey)(initialProduct)) {
        return `I already have \n ${initialProduct.game.name} key`;
    }
    return `I already have \n ${initialProduct.name}`;
}
